module.exports = __webpack_public_path__ + "img/icon_pause.08a23bbb.svg";